import React, { Component } from 'react';

import TimeoutSignsParkinglocationsSelect from './TimeoutSignsParkinglocationsSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
const FormItem = Form.Item;

class TimeoutSignsSettingsForm extends Component {

  state = {
    modalVisible: false
  }

  form = null;

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        if (values.parkingLocationID && values.placeID) {
          values.eventListener = 'application/parking/' + values.parkingLocationID + '/place/' + values.placeID;
        }
        if (values.placeID) delete values.placeID;
        if (values.parkingLocationID) delete values.parkingLocationID;
        let position = {
          "type": "Point",
          "coordinates": [
            values.positionLon !== undefined ? values.positionLon : 0.0,
            values.positionLat !== undefined ? values.positionLat : 0.0
          ]
        };
        values.coords = position;
        delete values.positionLat;
        delete values.positionLon;
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    if (this.props.initialValues !== undefined && this.props.initialValues !== null) {
      var res = this.props.initialValues.eventListener.split("/");
      this.props.initialValues.parkingLocationID = res[2];
      this.props.initialValues.placeID = res[4];
    }

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
        <FormItem
          {...formItemLayout}
          label="Timer" >
          {getFieldDecorator('timerName', {
            initialValue: this.props.initialValues && this.props.initialValues.timerName
              ? this.props.initialValues.timerName
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Lokalita" >
          {getFieldDecorator('parkingLocationID', {
            initialValue: this.props.initialValues && this.props.initialValues.parkingLocationID
            ? this.props.initialValues.parkingLocationID
            : undefined,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <TimeoutSignsParkinglocationsSelect onChange={(value) => { this.props.form.setFieldsValue({ parkingLocationID: value });}} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Místo" >
          {getFieldDecorator('placeID', {
            initialValue: this.props.initialValues && this.props.initialValues.placeID
              ? this.props.initialValues.placeID
              : null,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Nastavený limit (min)" >
          {getFieldDecorator('timeLimit', {
            initialValue: this.props.initialValues && this.props.initialValues.timeLimit
              ? this.props.initialValues.timeLimit
              : 30,
            rules: [{
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zeměpisná šířka" >
          {getFieldDecorator('positionLat', {
            initialValue: this.props.initialValues && this.props.initialValues.coords
              ? this.props.initialValues.coords.coordinates[1]
              : 0,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Zeměpisná výška" >
          {getFieldDecorator('positionLon', {
            initialValue: this.props.initialValues && this.props.initialValues.coords
              ? this.props.initialValues.coords.coordinates[0]
              : 0,
            rules: [{
              type: 'number', message: 'Položka musí obsahovat číslo!',
            }],
          })(
            <InputNumber />
          )}
        </FormItem>
        {this.props.type && this.props.type !== 'modal'
          ? <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Uložit</Button>
          </FormItem>
          : null}
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          className={'cstm-modal-form'}
          width={700}
          title={this.props.initialValues ? "Nastavení timeout tabule" : "Vložení nové timeout tabule"}
          visible={this.state.modalVisible}
          maskClosable={false}
          onCancel={() => {
            this.props.onModalCancel(this.props.form);
            this.setState({ modalVisible: false });
          }}
          okText={this.props.initialValues ? "Uložit" : "Vložit"}
          onOk={this.handleSubmit} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(TimeoutSignsSettingsForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/TimeoutSignsSettingsForm.js